module.exports = __webpack_public_path__ + "img/people-yellow-icon.b6e940cd.png";